import React, { useEffect } from 'react';
import {
  useGetDefaultTemplateQuery,
  useLazyGetTemplatesQuery,
} from 'app/features/templates/api';
import { useLazyLoadOption } from 'app/hooks/useLazyLoadOption';
import { useLazyGetInspectionSampleSizeQuery } from 'app/features/inspection/api';

const InspectionContext = React.createContext<any>({});
//Requesting when poItem request get Sample Size and get Default Template.
const InspectionProvider: React.FC<any> = ({ children, inspection }) => {
  const [cachedSampleSize, setCachedSampleSize] = React.useState(new Map());

  const [fetchTemplates] = useLazyGetTemplatesQuery();
  const defaultTemplate = useGetDefaultTemplateQuery(null);
  const { data: templates, onScroll } = useLazyLoadOption({
    fetch: async (pagination) => {
      const { data: response } = await fetchTemplates({
        current: pagination.currentPage,
        pageSize: 10,
        status: 'active',
        excludes: 'scheme',
      } as any).unwrap();
      if (response.length === 1) {
        return templates.map(({ id }) => id).includes(response[0]?.id)
          ? []
          : response;
        //Default Always return;
      }
      return response;
    },
  });
  const { inspectionRequirement, inspectionPOItems } = inspection;

  const handleCachedSampleSize = React.useCallback(() => {
    inspectionPOItems.forEach((item) => {
      const {
        inspectionSubPOItems,
        sampleSize: defaultSampleSize,
        inspectionAQL,
      } = item;
      const quantity = inspectionSubPOItems
        .map(({ orderQty }) => Number(orderQty))
        .filter((orderQty) => !isNaN(orderQty))
        .reduce((a, b) => a + b, 0);

      const params = {
        qty: quantity,
        inspectionLevel: inspectionRequirement.generalInspectLevel,
        inspectionAqlCritical: inspectionAQL.criticalLevel,
        inspectionAqlMajor: inspectionAQL.criticalMajorLevel,
        inspectionAqlMinor: inspectionAQL.criticalMinorLevel,
      };
      if (!cachedSampleSize.has(JSON.stringify(params)) && defaultSampleSize) {
        setCachedSampleSize((prev) => {
          const newCached = new Map(prev);
          newCached.set(JSON.stringify(params), defaultSampleSize);
          return newCached;
        });
      }
    });
  }, [inspectionPOItems]);

  useEffect(() => {
    handleCachedSampleSize();
  }, [handleCachedSampleSize]);

  const updateSampleSize = (params, sampleSize) => {
    if (!cachedSampleSize.has(JSON.stringify(params)) && sampleSize) {
      setCachedSampleSize((prev) => {
        const newCached = new Map(prev);
        newCached.set(JSON.stringify(params), sampleSize);
        return newCached;
      });
    }
  };

  useEffect(() => {
    //Initialize Cache For Sample Size.
    //  1. get the current inspection Po Items
    //  2. create params with qty , inspectionLevel, inspectionAqlCritical, inspectionAqlMajor, inspectionAqlMinor
    //  3. Check Cache existed key or not.
    //  3. get the sample size from the inspectionSubPOItems
    //  4. Get Sample Size
    //  5. Add cache into
  }, []);

  return (
    <InspectionContext.Provider
      value={{
        templates,
        onScrollTemplates: onScroll,
        defaultTemplate: defaultTemplate?.data,
        inspectionLevel: inspectionRequirement.generalInspectLevel,
        cachedSampleSize,
        updateSampleSize,
      }}
    >
      {children}
    </InspectionContext.Provider>
  );
};

// const useFetchSampleSize = (params) => {
//   const context = React.useContext(InspectionContext);
//   const { cachedSampleSize, updateSampleSize } = context;
//   const shouldFetchSampleSize = React.useMemo(() => {
//     if (!params) return false;
//     return !cachedSampleSize.has(JSON.stringify(params));
//   }, [params, cachedSampleSize]);

//   const [fetch, result] = useLazyGetInspectionSampleSizeQuery();

//   useEffect(() => {
//     if (shouldFetchSampleSize) {
//       fetch(params)
//         .unwrap()
//         .then((res: any) => {
//           updateSampleSize(params, res.data?.aql);
//         });
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [shouldFetchSampleSize, params]);

//   return {
//     sampleSize: cachedSampleSize.get(JSON.stringify(params)),
//     ...result,
//   };
// };

// const useFetchLinkageTemplate = (params) => {
//   const context = React.useContext(InspectionContext);
// };

export { InspectionProvider, InspectionContext };
